export const API_USERS_HOST = "https://10.1.61.1:9007";
export const API_HOST = "https://backend.lettaiot.com:8000";
export const UI_HOST = "https://ui.lettaiot.com:8000";
